var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "py-6" }, [
    _c("h3", { staticClass: "text-lg font-medium mb-4" }, [
      _vm._v(" Step 6 of 9: Personal Considerations "),
    ]),
    _c(
      "div",
      { staticClass: "grid grid-cols-1 gap-3" },
      [
        _c("h5", { staticClass: "text-lg font-medium mb-1" }, [
          _vm._v("Home Environment"),
        ]),
        _c("ValidationProvider", {
          attrs: { name: "Pets" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v("Pets "),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v("(optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormMultiselect", {
                        attrs: {
                          name: "pets",
                          getParentCustom: "clientWidth",
                          placeholder: "Select pets",
                          options: _vm.petOptions,
                          multiple: true,
                          inputClass: "w-full",
                        },
                        on: { input: (val) => _vm.updateField("pets", val) },
                        model: {
                          value: _vm.formData.pets,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "pets", $$v)
                          },
                          expression: "formData.pets",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
        _c("ValidationProvider", {
          attrs: { name: "Accessibility Issues" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v(" Accessibility Issues "),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v("(optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormInputGroup", {
                        attrs: {
                          name: "accessibility_issues",
                          getParentCustom: "clientWidth",
                          placeholder: "Enter accessibility issues",
                          inputClass: "w-full",
                        },
                        on: {
                          input: (val) =>
                            _vm.updateField("accessibility_issues", val),
                        },
                        model: {
                          value: _vm.formData.accessibility_issues,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "accessibility_issues", $$v)
                          },
                          expression: "formData.accessibility_issues",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
        _c("ValidationProvider", {
          attrs: { name: "Safety Concerns" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v(" Safety Concerns "),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v("(optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormInputGroup", {
                        attrs: {
                          name: "safety_concerns",
                          getParentCustom: "clientWidth",
                          placeholder: "Enter safety concerns",
                          inputClass: "w-full",
                        },
                        on: {
                          input: (val) =>
                            _vm.updateField("safety_concerns", val),
                        },
                        model: {
                          value: _vm.formData.safety_concerns,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "safety_concerns", $$v)
                          },
                          expression: "formData.safety_concerns",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
        _c("ValidationProvider", {
          attrs: { name: "Smart Home Features" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v(" Smart Home Features "),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v("(optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormMultiselect", {
                        attrs: {
                          name: "smart_home_features",
                          getParentCustom: "clientWidth",
                          placeholder: "Enter smart home features",
                          options: [
                            { label: "Yes", value: "Yes" },
                            { label: "No", value: "No" },
                          ],
                          inputClass: "w-full",
                        },
                        on: {
                          input: (val) =>
                            _vm.updateField("smart_home_features", val),
                        },
                        model: {
                          value: _vm.formData.smart_home_features,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "smart_home_features", $$v)
                          },
                          expression: "formData.smart_home_features",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
        _c("h5", { staticClass: "text-lg font-medium mb-1" }, [
          _vm._v("Personal Preferences"),
        ]),
        _c("ValidationProvider", {
          attrs: { name: "Hobbies" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v("Hobbies "),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v("(optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormMultiselect", {
                        attrs: {
                          name: "hobbies",
                          getParentCustom: "clientWidth",
                          placeholder: "Enter hobbies",
                          options: _vm.hobbyOptions,
                          multiple: true,
                          inputClass: "w-full",
                        },
                        on: { input: (val) => _vm.updateField("hobbies", val) },
                        model: {
                          value: _vm.formData.hobbies,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "hobbies", $$v)
                          },
                          expression: "formData.hobbies",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
        _c("ValidationProvider", {
          attrs: { name: "Interests" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v(" Interests "),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v("(optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormInputGroup", {
                        attrs: {
                          name: "interests",
                          placeholder: "Enter interests",
                          inputClass: "w-full",
                        },
                        on: {
                          input: (val) => _vm.updateField("interests", val),
                        },
                        model: {
                          value: _vm.formData.interests,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "interests", $$v)
                          },
                          expression: "formData.interests",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
        _c("ValidationProvider", {
          attrs: { name: "Cultural Considerations" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v(" Cultural Considerations "),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v("(optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormInputGroup", {
                        attrs: {
                          name: "cultural_considerations",
                          placeholder: "Enter cultural considerations",
                          inputClass: "w-full",
                        },
                        on: {
                          input: (val) =>
                            _vm.updateField("cultural_considerations", val),
                        },
                        model: {
                          value: _vm.formData.cultural_considerations,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formData,
                              "cultural_considerations",
                              $$v
                            )
                          },
                          expression: "formData.cultural_considerations",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
        _c("ValidationProvider", {
          attrs: { name: "Religious Practices" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v(" Religious Practices "),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v("(optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormInputGroup", {
                        attrs: {
                          name: "religious_practices",
                          placeholder: "Enter religious practices",
                          inputClass: "w-full",
                        },
                        on: {
                          input: (val) =>
                            _vm.updateField("religious_practices", val),
                        },
                        model: {
                          value: _vm.formData.religious_practices,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "religious_practices", $$v)
                          },
                          expression: "formData.religious_practices",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
        _c("ValidationProvider", {
          attrs: { name: "Dietary Restrictions" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v(" Dietary Restrictions "),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v("(optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormInputGroup", {
                        attrs: {
                          name: "dietary_restrictions",
                          placeholder: "Enter dietary restrictions",
                          inputClass: "w-full",
                        },
                        on: {
                          input: (val) =>
                            _vm.updateField("dietary_restrictions", val),
                        },
                        model: {
                          value: _vm.formData.dietary_restrictions,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "dietary_restrictions", $$v)
                          },
                          expression: "formData.dietary_restrictions",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }